
import React , {useEffect} from 'react' 

import { useNavigate , useLocation } from "react-router-dom";

import "./styles.css"

export default function Header() {

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    console.log(location)
    if ( location.state === null || location.state.email === undefined || location.state.email  === "/"){
      navigate("/")
    }
  }, [])


  function onCampains(){
    navigate("/campains" , { state : { nombre : location.state.nombre , email : location.state.email , password : location.state.password } })
    //console.log( "onCampains")
  }

  function onClientes(){
    navigate("/clientes", { state : { nombre : location.state.nombre, email : location.state.email, password : location.state.password } })
  } 

  function onHorarios(){
    navigate("/horarios", { state : { nombre : location.state.nombre, email : location.state.email, password : location.state.password } })
  }

  function onCampainSetUp(){
    console.log( "onCampainSetUp")
    navigate("/campainsetup", { state : { nombre : location.state.nombre, email : location.state.email, password : location.state.password } })
  }

  function onSentMessages(){
    console.log( "onSentMessages")
    navigate("/sentmessages", { state : { nombre : location.state.nombre, email : location.state.email, password : location.state.password } })
  }



  function onSalir(){
    navigate("/")
  }

  return (
    <div className='w-100'>

      <div className='row'>

        <div className='col-10'>
          <h1 className='text-center'>Digital Sms</h1>
        </div>

        <div className='col-2 pt-2'>

          <p style={{fontSize:'18px'}}>{location.state.nombre}</p>

        </div>

        
      </div>

    




        <div className='nav mb-5' style={{width:'100%' }}>
        <ul >
            <li><a  href="#home" class="active" >Home</a></li>
            <li><a onClick={onCampains}  >Carga Campañas</a></li>
            <li><a onClick={onClientes}  >Clientes</a></li>
            <li><a onClick={onHorarios}  >Carga Horarios</a></li>
            <li><a onClick={onCampainSetUp}  >Campaña SetUp</a></li>
            <li><a onClick={onSentMessages}  >Mensajes Enviados</a></li>
            <li><a onClick={()=> navigate("/about")} >About</a></li>
            <li><a onClick={onSalir}  >Salir</a></li>
        </ul>
    </div>




</div>

  )
}
